export default "__VITE_ASSET__Dvs11H6C__"